import React from 'react';
import { Waves } from 'lucide-react';
import { AudioEffect, AudioEffectControlProps } from './AudioEffect';
import { AudioSourceRegistry } from '../../../../dataTypes/liveStreamManagment/audioPipeline/AudioSourceRegistry';
import { LevelSlider } from '../LevelSlider';

export interface ReverbConfig {
  /** Proportion de signal réverbéré ajouté, en % (0-100) — le signal sec n'est jamais
   * réduit (cf. AudioSourceRegistry : dryGain toujours à 1, la reverb est un send). */
  mix: number;
  /** Durée de la traîne, en secondes — taille de pièce perçue (0.2 à petit local,
   * 4 grande salle). Régénère l'impulsion côté registry, mise en cache par durée. */
  decaySec: number;
}

class ReverbEffectImpl extends AudioEffect<ReverbConfig> {
  readonly id = 'reverb';
  readonly label = 'Réverb';
  readonly icon = Waves;
  readonly description = 'Réverbération légère — ambiance de pièce, envoi seul';
  readonly defaultConfig: ReverbConfig = { mix: 25, decaySec: 1.6 };

  apply(registry: AudioSourceRegistry, regId: string, enabled: boolean, config: ReverbConfig): void {
    registry.setReverb(regId, enabled, config.mix / 100, config.decaySec);
  }

  renderControls({ config, onChange }: AudioEffectControlProps<ReverbConfig>) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <LevelSlider
          label="Mix" value={config.mix}
          min={0} max={100} defaultValue={25}
          format={v => `${v}%`}
          onChange={mix => onChange({ ...config, mix })}
        />
        <LevelSlider
          label="Durée" value={config.decaySec}
          min={0.2} max={4} defaultValue={1.6} roundTo={0.1}
          format={v => `${v.toFixed(1)}s`}
          onChange={decaySec => onChange({ ...config, decaySec })}
        />
      </div>
    );
  }
}

export const reverbEffect = new ReverbEffectImpl();
